import * as _ from "lodash";
import {Install} from "../models/Install";
import {CachingCollection} from "./_BaseCollection";

export  class  InstallCollection extends CachingCollection<Install> {

    constructor(initialModels?, options?) {
        super(initialModels, _.extend({model: Install}, options));
    }

    url = () => {
        return window.location.origin + '/api/v1/installs';
    };

    comparator = (model) => {
        return model.get('organization_install_name');
    };

    getOrgInstall(installId: number, organizationId?: number, orgOptional?: boolean) {
        var query = {id: installId};
        if (organizationId) query['organization_id'] = organizationId;
        var result = this.findWhere(query);

        if (!result && organizationId && orgOptional) {
            result = this.findWhere({id: installId});
        }
        return result;
    }

    groupByOrgId() {
        return _.groupBy(this.models, ((install) => {
            return install.getLinkOrg()
        }));
    }

    allByOrgId = _.memoize((orgId) => {
        return _.sortBy(this.filter((install) => {
            return install.get('organization_id') === orgId
        }), (install) => {
           return install.getDisplayName()
        });
    }, (k) => {
        return this.etag + k
    });

}



// WEBPACK FOOTER //
// ./srv/public/js/collections/Installs.ts